import { render } from "./Footer.vue?vue&type=template&id=6a24b0cc&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=6a24b0cc&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4102021654/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a24b0cc"]])

export default __exports__